"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _FormModal = _interopRequireDefault(require("../../../components/Modals/FormModal"));
var _Loader = _interopRequireDefault(require("../../../components/Loader"));
var _Enrolment = _interopRequireDefault(require("./Enrolment"));
var _CoverageSelection = _interopRequireDefault(require("./CoverageSelection"));
var _Confirmation = _interopRequireDefault(require("./Confirmation"));
var _Agreement = _interopRequireDefault(require("./Agreement"));
var Services = _interopRequireWildcard(require("../../../services"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PurchaseFlow = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(PurchaseFlow, _PureComponent);
  function PurchaseFlow() {
    var _this;
    (0, _classCallCheck2["default"])(this, PurchaseFlow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, PurchaseFlow, [].concat(args)), _this.state = {
      step: 0,
      purchaseData: _objectSpread(_objectSpread({}, _this.props.selectedProduct.productPurchaseTemplate), {}, {
        signage: {
          name: '',
          signature: '',
          acceptedTerms: false,
          timestampOfAcceptance: null,
          datedOn: ''
        },
        password: '',
        memberData: _objectSpread({}, _this.props.member)
      }),
      enrolmentErrors: [],
      confirmationErrors: {
        agreement: false,
        signage: false,
        password: false,
        name: false,
        signature: false,
        datedOn: false
      }
    }, _this._validateEnrolmentQuestions = function () {
      var enrolmentErrors = {};
      var questionIDs = Object.keys(_this.props.selectedProduct.enrolmentQuestions);
      for (var _i = 0, _questionIDs = questionIDs; _i < _questionIDs.length; _i++) {
        var questionID = _questionIDs[_i];
        if (_this.state.purchaseData.enrolmentQuestions[questionID].answer === null) {
          enrolmentErrors[questionID] = true;
        }
      }
      _this.setState({
        enrolmentErrors: enrolmentErrors
      });
      return Object.keys(enrolmentErrors).length === 0;
    }, _this._validateSignageBlock = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var passwordError, signageNameError, signageSignatureError, signageDatedOnError, acceptedTerms;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!_this.props.isMasterSite) {
              _context.next = 4;
              break;
            }
            _context.t0 = null;
            _context.next = 7;
            break;
          case 4:
            _context.next = 6;
            return Services.validateInput('checkEmpty', _this.state.purchaseData.password);
          case 6:
            _context.t0 = _context.sent;
          case 7:
            passwordError = _context.t0;
            _context.next = 10;
            return Services.validateInput('checkEmpty', _this.state.purchaseData.signage.name);
          case 10:
            signageNameError = _context.sent;
            _context.next = 13;
            return Services.validateInput('checkEmpty', _this.state.purchaseData.signage.signature);
          case 13:
            signageSignatureError = _context.sent;
            _context.next = 16;
            return Services.validateInput('date', _this.state.purchaseData.signage.datedOn, _i18n["default"].locale);
          case 16:
            signageDatedOnError = _context.sent;
            acceptedTerms = _this.state.purchaseData.signage.acceptedTerms === false;
            if (_this.state.purchaseData.signage.name !== _this.state.purchaseData.signage.signature) {
              signageNameError = 'The name and signature must match.';
            }
            _this.setState({
              confirmationErrors: _objectSpread(_objectSpread({}, _this.state.confirmationErrors), {}, {
                name: signageNameError,
                signature: signageSignatureError,
                datedOn: signageDatedOnError,
                password: passwordError,
                agreement: acceptedTerms
              })
            });
            if (!(signageNameError || signageSignatureError || signageDatedOnError || passwordError || acceptedTerms)) {
              _context.next = 22;
              break;
            }
            return _context.abrupt("return", false);
          case 22:
            return _context.abrupt("return", true);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._nextStep = function () {
      var stepIncrease = 1;

      // if we are moving on from the enrolment step, ensure we have answers to all the enrolment questions
      if (_this.state.step === 0) {
        var enrolmentValid = _this._validateEnrolmentQuestions();
        if (!enrolmentValid) {
          return null;
        }
        if (_this.props.selectedProduct.pricingType === 'static') {
          stepIncrease = 2;
        }
      }
      _this.setState({
        step: _this.state.step + stepIncrease
      });
    }, _this._previousStep = function () {
      var stepDecrease = 1;

      // if we moving back from the confirmation page, make sure we don't go to the coverage step if it's static
      if (_this.state.step === 2) {
        if (_this.props.selectedProduct.pricingType === 'static') {
          stepDecrease = 2;
        }
      }
      _this.setState({
        step: _this.state.step - stepDecrease
      });
    }, _this._savePurchaseData = function (data) {
      _this.setState({
        purchaseData: _objectSpread({}, data)
      });
    }, _this._purchaseProduct = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var signageValid, success;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this._validateSignageBlock();
          case 2:
            signageValid = _context2.sent;
            if (signageValid) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return", false);
          case 5:
            // if it's the master site, we don't need the password for validation
            if (_this.props.isMasterSite) {
              delete _this.state.purchaseData.password;
            }

            // we don't need to save the memberData;
            delete _this.state.purchaseData.memberData;
            _context2.next = 9;
            return _this.props.purchaseProduct(_objectSpread(_objectSpread({}, _this.state.purchaseData), {}, {
              signage: _objectSpread(_objectSpread({}, _this.state.purchaseData.signage), {}, {
                datedOn: Services.dates.formatOutgoingDate(_this.state.purchaseData.signage.datedOn)
              })
            }));
          case 9:
            success = _context2.sent;
            if (success) {
              _this.props.onClose();
            }
            return _context2.abrupt("return", null);
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), (0, _assertThisInitialized2["default"])(_this)));
  }
  /**
  * For each product enrolment question, ensure we have saved an answer for each one
  *
  * @function
  * @returns {boolean} - Returns `true` if all enrolment questions have answers, `false` otherwise.
  * @private
  */
  // eslint-disable-next-line consistent-return
  /**
   * Initiates the product purchase process, validates the signage block, and completes the purchase if successful.
   *
   * @async
   * @function
   */
  (0, _createClass2["default"])(PurchaseFlow, [{
    key: "render",
    value: function render() {
      if (!this.state.purchaseData) {
        return null;
      }
      var step = this.state.step;
      var product = this.props.selectedProduct;
      return /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: true,
        close: this.props.onClose,
        title: step === 0 ? _i18n["default"].t(_tokens["default"].labels.marketplace.welcomeToTheSimplyBenefitsMarketplace) : step === 1 ? _i18n["default"].t(_tokens["default"].labels.marketplace.selectCoverage) : step === 2 ? _i18n["default"].t(_tokens["default"].labels.confirmation) : _i18n["default"].t(_tokens["default"].labels.marketplace.agreement),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: step < 3 ? this._nextStep : this._purchaseProduct,
        saveButtonText: this.state.step === 3 ? _i18n["default"].t(_tokens["default"].buttons.completePurchase) : this.state.step === 2 ? _i18n["default"].t(_tokens["default"].buttons.confirmPurchase) : _i18n["default"].t(_tokens["default"].buttons.next),
        onBack: step === 0 ? null : this._previousStep,
        maxWidth: "lg",
        customContainerStyle: {
          maxWidth: 800
        },
        customFormStyle: {
          width: 700
        }
      }, step === 0 && /*#__PURE__*/_react["default"].createElement(_Enrolment["default"], {
        product: product,
        member: this.state.purchaseData.memberData,
        purchaseData: this.state.purchaseData,
        enrolmentErrors: this.state.enrolmentErrors,
        savePurchaseData: this._savePurchaseData
      }), step === 1 && /*#__PURE__*/_react["default"].createElement(_CoverageSelection["default"], {
        member: this.state.purchaseData.memberData,
        product: product,
        purchaseData: this.state.purchaseData,
        savePurchaseData: this._savePurchaseData,
        getRate: this.props.getRate
      }), step === 2 && /*#__PURE__*/_react["default"].createElement(_Confirmation["default"], {
        member: this.state.purchaseData.memberData,
        product: product,
        purchaseData: this.state.purchaseData,
        whitelabel: this.props.whitelabel
      }), step === 3 && /*#__PURE__*/_react["default"].createElement(_Agreement["default"], {
        isMasterSite: this.props.isMasterSite,
        member: this.state.purchaseData.memberData,
        product: product,
        purchaseData: this.state.purchaseData,
        savePurchaseData: this._savePurchaseData,
        whitelabel: this.props.whitelabel,
        confirmationErrors: this.state.confirmationErrors
      }), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      }));
    }
  }]);
  return PurchaseFlow;
}(_react.PureComponent);
var _default = exports["default"] = PurchaseFlow;